import T from 'i18n-react';

import { ACCOUNT_CATEGORIES } from './AccountPage.consts';

T.setTexts(require('Components/texts.json'));

export const getNavigationHeaderTexts = (category, slug) => {
	const categoryTypes = {
		[ACCOUNT_CATEGORIES.BIDS]: {
			text: 'bidsOffers',
		},
		[ACCOUNT_CATEGORIES.PURCHASES]: {
			text: 'purchases',
		},
	};

	const { text } = categoryTypes[category];

	return {
		category: String(T.translate(`account.navigation.${text}`)),
		slug: String(T.translate(`account.sidebar.sectionLinks.${slug}`)),
	};
};
